<app-journey-list
  [launcherMode]="'true'"
  [csrFilter]="csrFilter"
  [limit]="limit"
></app-journey-list>
